// Add this line
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { ScoreCardPropTypes } from '../../features/compensation/types';
import {
    useGetPrimaryApprovalWindowQuery,
    useGetScorecardStatusQuery,
    useUpdateCertifiedScorecardApprovalWindowMutation,
} from '../../pages/compensation/compensationSlice';
import { selectCurrentEmpid } from '../../pages/login/authSlice';
import { ScorecardWindowComments } from '../scorecardWindowComments/ScorecardWindowComments';

export const CertifyApprovalProcess = ({
    inputYear,
    inputMonth,
    inputScorecardVersion,
}: ScoreCardPropTypes) => {
    const currentEmpid = useSelector(selectCurrentEmpid);
    const [updateCertifiedScorecardApprovalWindow] = useUpdateCertifiedScorecardApprovalWindowMutation();
    const [isCertified, setIsCertified] = React.useState(false);
    const [buttonColor, setButtonColor] = React.useState('#0288D1');
    const [approvalWindowId, setApprovalWindowId] = React.useState(0);
    const [showCommentsDialog, setShowCommentsDialog] = React.useState(false);

    const { data: scorecardStatusData } = useGetScorecardStatusQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );

    const { data: primaryApprovalWindowData } = useGetPrimaryApprovalWindowQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            approvalWindowConfigLevelId: 3,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );

    useEffect(() => {
        const windowData = primaryApprovalWindowData?.data[0];
        if (windowData?.certified === true) {
            setButtonColor('green');
            setIsCertified(true);
        } else {
            setButtonColor('#0288D1');
            setIsCertified(false);
        }
        setApprovalWindowId(windowData?.scorecard_approval_window_id);
    }, [primaryApprovalWindowData]);

    const accept = () => {
        if (scorecardStatusData?.data?.length > 0) {
            if (
                scorecardStatusData?.data?.[0].open_metric_disputes > 0 ||
                scorecardStatusData?.data?.[0].open_scorecard_disputes > 0
            ) {
                toast.warn('Disputes must be cleared before certifying.');
            } else {
                const certifyStatus = {
                    year: inputYear,
                    month: inputMonth,
                    scorecardVersionId: inputScorecardVersion,
                    certified: true,
                    certifiedBy: currentEmpid,
                };

                updateCertifiedScorecardApprovalWindow(certifyStatus)
                    .unwrap()
                    .then(() => {
                        toast.success('Certify flag updated successfully');
                    })
                    .then((error: any) => {
                        if (error) {
                            toast.error('Certify flag update failed');
                        }
                    });
            }
        } else {
            toast.warn('Disputes must be cleared before certifying.');
        }
    };

    const reject = () => {
        toast.warn('You have rejected..');
    };
    const onConfirm = () => {
        if (isCertified === true) {
            toast.warn('Data has been confirmed');
        } else {
            confirmDialog({
                message: 'Process will check if “Certified” (flag) before opening window',
                header: 'Certify Data',
                icon: 'pi pi-info-circle',
                accept,
                reject,
            });
        }
    };
    const closeCommentsDialog = (message: boolean) => {
        setShowCommentsDialog(!message);
    };
    return (
        <div>
            <h5>Certify Data</h5>
            <p>
                Certify and confirm all data is up to date and ready for associate and team lead approval for
                the chosen month.
            </p>
            <div className="flexButtons mt-3">
            <Button
                label="Comments"
                onClick={()=>setShowCommentsDialog(true)}
                className="btn-secondary me-2" />
            <Button
                className="btn-primary float-end"
                style={{ fontSize: '12px', borderRadius: '8px', backgroundColor: buttonColor }}
                onClick={onConfirm}
            >
                {isCertified ? 'Confirmed' : 'Confirm'}
            </Button>
            </div>
            {showCommentsDialog &&
                <ScorecardWindowComments
                    showCommentsDialog={showCommentsDialog}
                    closeCommentsDialog={closeCommentsDialog}
                    approvalWindowId={approvalWindowId}
                />
            }
        </div >
    );
};
